/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ArticleCarriersResponse } from '../../models/article-carriers-response';
import { KeyType } from '../../models/key-type';

export interface GetCheckinArticleCarriers$Params {
  organizationSiteKey: KeyType;
  checkinKey: string;
}

export function getCheckinArticleCarriers(http: HttpClient, rootUrl: string, params: GetCheckinArticleCarriers$Params, context?: HttpContext): Observable<StrictHttpResponse<ArticleCarriersResponse>> {
  const rb = new RequestBuilder(rootUrl, getCheckinArticleCarriers.PATH, 'get');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
    rb.path('checkinKey', params.checkinKey, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ArticleCarriersResponse>;
    })
  );
}

getCheckinArticleCarriers.PATH = '/organization-sites/{organizationSiteKey}/consignee/checkins/{checkinKey}/article-carriers';
